"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderConfirmation = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = require("styled-components");
const canvas_box_1 = require("../canvas-box");
const themed_text_1 = require("../themed-text");
const styles_1 = require("./styles");
const OrderConfirmation = (props) => {
    const { orderPlacedCopy, orderReviewCopy } = props;
    const { spacings: { base } } = (0, styled_components_1.useTheme)();
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(canvas_box_1.CanvasContainer, { alignItems: "center", direction: "row", margin: `${base} 0` },
            react_1.default.createElement("i", { "data-cy": "order-confirmation-icon", style: { flexShrink: 0 }, className: "a-icon a-icon-success" }),
            react_1.default.createElement(styles_1.StyledConfirmationHeading, { bold: true, headingLevel: 2, font: "medium" }, orderPlacedCopy)),
        react_1.default.createElement(themed_text_1.ThemedParagraph, { font: "base" }, orderReviewCopy)));
};
exports.OrderConfirmation = OrderConfirmation;
__exportStar(require("./types"), exports);
